module.exports = __webpack_public_path__ + "5fb8b14c6fceb1bd5a1de689632e2d9e.png";